(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-expandable-text]').forEach(textEl => {
    const button = textEl.nextElementSibling;

    const fullText = textEl.textContent.trim();
    const rawLimit = textEl.getAttribute('data-truncate-words');
    const wordLimit = Number(rawLimit) || 14;

    const words = fullText.split(/\s+/);

    // Always create truncated version
    const truncatedText =
      words.length > wordLimit
        ? words.slice(0, wordLimit).join(' ') + '...'
        : fullText;

    let expanded = false;

    // Initial state
    textEl.textContent = truncatedText;

    // Hide button ONLY if truncation is unnecessary
    if (words.length <= wordLimit) {
      button.style.display = 'none';
      return;
    }

    button.addEventListener('click', () => {
      expanded = !expanded;

      textEl.style.opacity = '0';

      requestAnimationFrame(() => {
        textEl.textContent = expanded ? fullText : truncatedText;

        button.querySelector('[data-toggle-label]').textContent =
          expanded ? button.dataset.reduceText : button.dataset.expandText;

        button.classList.toggle('is-expanded', expanded);
        button.setAttribute('aria-expanded', expanded);
        textEl.style.opacity = '1';
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
